export const API_KEY = "AIzaSyDjAEzHTui9VVat3Fu6aum-qoAzWBEt7Ng";

export default API_KEY;